// Handlers for auth related actions

import type {
  SetAuthAction,
  UpdateAuthsAction,
  UpdateAuthsStatusAction,
  UserState,
} from './types';

export const updateAuthsHandler = (
  state: UserState,
  { payload }: UpdateAuthsAction,
): UserState => ({
  ...state,
  auths: payload,
});

export const updateAuthsStatusHandler = (
  state: UserState,
  { payload }: UpdateAuthsStatusAction,
): UserState => ({
  ...state,
  auths: state.auths.map((auth) =>
    auth._id === payload?.authId ? { ...auth, status: payload?.status } : auth,
  ),
});

export const setAuthHandler = (
  state: UserState,
  { payload }: SetAuthAction,
): UserState => ({
  ...state,
  auths: [...(state?.auths || []), payload],
});
